import useServiceFactory from "../serviceFactory";

const apiUrl = `/externos/jira`;

const useApiJira = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });
    return {
        obtener: async (params) => service.get(`${apiUrl}/obtener`, { params, showLoading: true }),
        obtenerFuture: async (params) => service.get(`${apiUrl}/obtenerFuture`, { params, showLoading: true }),
        obtenerEpics: async (params) => service.get(`${apiUrl}/obtenerEpics`, { params, showLoading: true }),
    }
};

export default useApiJira;
